// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialButtonsShare_root___27VM","button":"SocialButtonsShare_button__6ychj","vk":"SocialButtonsShare_vk__3Hkqh","tg":"SocialButtonsShare_tg__2lUZl"};